import Task from "../models/Task";

const TaskStore = Task.create();

export default TaskStore;
